"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IPAPER_SCRIPT_URL = exports.IPAPER_SCRIPT_ID = exports.IPAPER_ROOT_ID = exports.IPAPER_IFRAME_ID = void 0;
const IPAPER_SCRIPT_URL = exports.IPAPER_SCRIPT_URL = 'https://cdn.ipaper.io/flipbooks/api/v3/latest.js';
const IPAPER_SCRIPT_ID = exports.IPAPER_SCRIPT_ID = 'ipaper-script';
const IPAPER_IFRAME_ID = exports.IPAPER_IFRAME_ID = 'ipaper-catalogue';
const IPAPER_ROOT_ID = exports.IPAPER_ROOT_ID = 'catalogue-ipaper-root';
